import { AuthContext, LoginPage, SigninOidc, SettingsContext, useFeature } from "adviesbox-shared";
import React, { ReactElement, useContext } from "react";
import { Route } from "react-router";
import logo from "../assets/new-brand-logo.svg";
import StartschermAjax from "../start-scherm/startscherm-ajax";
import { UpscopeProvider } from "@mvkdev/upscope-react-16";

const PortalApp = (): ReactElement => {
  const { user } = useContext(AuthContext);
  const featureUpscope = useFeature("FeatureUpscope");
  const settingsContext = useContext(SettingsContext);

  if (user) {
    return (
      <UpscopeProvider apiKey={settingsContext.upscopeApiKey} enabled={!!featureUpscope}>
        <div data-testid="startscherm">
          <Route path="/" exact component={StartschermAjax} />
          <Route path="*" />
        </div>
      </UpscopeProvider>
    );
  }

  return (
    <>
      <Route path="/signin-oidc" component={SigninOidc} />
      <LoginPage appLogo={logo} />
    </>
  );
};

PortalApp.displayName = "PortalApp";

export default PortalApp;
